<template>
  <NuxtLayout name="default">
    <template #header>
      <SiteHeader>
        <template #hero>
          <slot name="pageHero" />
        </template>
      </SiteHeader>
    </template>

    <template #content>
      <main class="relative bg-white z-20">
        <LazyDrupalTabs v-if="page.local_tasks" :tabs="page.local_tasks" />
        <div class="basic-page-body drupal-markup max-w-7xl mx-auto my-21">
          <slot name="content" />
        </div>
        <slot name="components" />
      </main>
    </template>
  </NuxtLayout>
</template>

<script setup lang="ts">
const { fetchPage } = useDrupalCe();

const page = await fetchPage(useRoute().path, { query: useRoute().query });

defineSlots<{
  components?(): any;
  content?(): any;
  pageHero?(): any;
}>();

// default props passed in, defined to stop warnings in console
defineProps<{
  body?: any;
  created?: any;
  // todo confirm if basic page would have layout type
  layoutType?: string;
  title?: string;
  uid?: string | object;
}>();
</script>

<style scoped>
.basic-page-body :deep(.table) {
  width: 100%;
}
</style>
